export default __webpack_public_path__ + "static/media/SWT0360.34I-27870_-16743_0.2cd31b83.jpg";